// Mirrors palma-bay-motos-front/src/utils/season.js: each season lasts until the other one starts, every year.
export const START_REGEX = /^(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]) ([01]\d|2[0-3]):[0-5]\d$/;

// Current Madrid time as "MM-DD HH:mm", comparable as a string with the season starts
const nowInMadrid = (now = new Date()) => {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Madrid", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23"
  }).formatToParts(now).reduce((acc, { type, value }) => ({ ...acc, [type]: value }), {});
  return `${parts.month}-${parts.day} ${parts.hour}:${parts.minute}`;
};

export const getCurrentSeasonName = (seasons, now = new Date()) => {
  const { summer, winter } = seasons || {};
  if (!summer || !winter || !START_REGEX.test(summer.start) || !START_REGEX.test(winter.start)) return "winter";
  const current = nowInMadrid(now);
  const isSummer = summer.start < winter.start
    ? current >= summer.start && current < winter.start
    : current < winter.start || current >= summer.start;
  return isSummer ? "summer" : "winter";
};
